/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type EmployeeTierAllocation = "LOCATION_BASED_ALLOCATION" | "SERVICE_BASED_ALLOCATION" | "%future added value";
export type RestrictionTypes = "ATTRIBUTE" | "CYCLIC_NUMBER_LIMIT" | "FEATURE_RPC" | "MODULE" | "NUMBER_LIMIT" | "UNSPECIFIED_RESTRICTION" | "%future added value";
export type AppQueryVariables = {};
export type AppQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly email: string;
        readonly metadata: string | null;
        readonly profileImage: {
            readonly thumbImage: string;
        } | null;
        readonly forceForPass: boolean;
        readonly preferences: {
            readonly dateFormat: string;
            readonly language: string;
            readonly timeFormat: string;
            readonly timezone: string;
            readonly uiInfo: string;
        } | null;
        readonly userRoles: {
            readonly role: ReadonlyArray<{
                readonly levelDetails: {
                    readonly id?: string;
                } | null;
                readonly levelId: string;
                readonly roleId: string;
                readonly role: {
                    readonly id: string;
                    readonly roleName: string;
                    readonly isDefault: boolean;
                    readonly priority: number;
                    readonly level: string;
                    readonly moduleRoles: ReadonlyArray<{
                        readonly name: string;
                    }>;
                } | null;
            }>;
        } | null;
        readonly groups: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly groupSettings: {
                readonly id: string;
                readonly adminCss: string;
                readonly metadata: string | null;
                readonly hasExtendedFields: boolean;
            } | null;
            readonly companies: ReadonlyArray<{
                readonly id: string;
                readonly title: string;
                readonly displayName: string;
                readonly profession: string;
                readonly active: boolean;
                readonly customCompanyId: string;
                readonly preference: {
                    readonly currency: string;
                    readonly dateFormat: string;
                    readonly language: string;
                    readonly timeFormat: string;
                    readonly timezone: string;
                    readonly uiInfo: string;
                } | null;
                readonly metadata: string | null;
                readonly gallery: {
                    readonly default: {
                        readonly thumbImage: string;
                        readonly largeImage: string;
                    } | null;
                    readonly images: ReadonlyArray<{
                        readonly largeImage: string;
                        readonly thumbImage: string;
                    }>;
                } | null;
                readonly address: {
                    readonly country: string;
                    readonly latitude: number;
                    readonly locality: string;
                    readonly longitude: number;
                    readonly postalCode: string;
                    readonly region: string;
                    readonly streetAddress: string;
                } | null;
                readonly companySettings: {
                    readonly id: string;
                    readonly navMenus: ReadonlyArray<string>;
                    readonly aliases: string | null;
                    readonly customization: {
                        readonly disableApps: ReadonlyArray<string>;
                        readonly disableStaffBooking: boolean;
                        readonly displayIntakeFormField: boolean;
                    } | null;
                } | null;
                readonly roleLevelCustomization: {
                    readonly disableApps: ReadonlyArray<string>;
                    readonly readonlyApps: ReadonlyArray<string>;
                } | null;
                readonly apps: ReadonlyArray<{
                    readonly id: string;
                    readonly appTypeId: string;
                    readonly name: string;
                    readonly active: boolean;
                    readonly serviceModules: ReadonlyArray<string>;
                }>;
                readonly slugObject: {
                    readonly id: string;
                    readonly slugType: string;
                    readonly slugValue: string;
                } | null;
                readonly telephones: ReadonlyArray<string>;
                readonly description: string;
                readonly emails: ReadonlyArray<string>;
                readonly locations: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly name: string;
                            readonly customLocationId: string;
                            readonly preference: {
                                readonly currency: string;
                                readonly dateFormat: string;
                                readonly language: string;
                                readonly timeFormat: string;
                                readonly timezone: string;
                                readonly uiInfo: string;
                            } | null;
                            readonly slugObject: {
                                readonly id: string;
                                readonly slugType: string;
                                readonly slugValue: string;
                            } | null;
                            readonly address: {
                                readonly country: string;
                                readonly latitude: number;
                                readonly locality: string;
                                readonly longitude: number;
                                readonly postalCode: string;
                                readonly region: string;
                                readonly streetAddress: string;
                            } | null;
                            readonly telephones: ReadonlyArray<string>;
                            readonly description: string;
                            readonly gallery: {
                                readonly default: {
                                    readonly largeImage: string;
                                    readonly thumbImage: string;
                                } | null;
                                readonly images: ReadonlyArray<{
                                    readonly largeImage: string;
                                    readonly thumbImage: string;
                                }>;
                            } | null;
                            readonly active: boolean;
                            readonly metadata: string | null;
                            readonly appointmentBookingFlowSetting: {
                                readonly id: string;
                                readonly enableTierBasedStaffPrioritization: boolean;
                                readonly tierEmployeeAllocation: EmployeeTierAllocation;
                            } | null;
                        } | null;
                    }>;
                } | null;
                readonly licenseWallet: {
                    readonly license: {
                        readonly moduleLicenses: ReadonlyArray<{
                            readonly enabled: boolean;
                            readonly freeLimit: number;
                            readonly licenseLimit: number;
                            readonly maxAddonLimit: number;
                            readonly maxLimit: number;
                            readonly moduleName: string;
                            readonly paidAddonLimit: number;
                            readonly restrictionSlugs: ReadonlyArray<string>;
                            readonly restrictionType: RestrictionTypes;
                            readonly rpcs: ReadonlyArray<string>;
                            readonly slug: string;
                            readonly totalLimit: number;
                        }>;
                    } | null;
                } | null;
            }>;
        }>;
        readonly tokenValidTill: string | null;
    };
    readonly wizardPosition: {
        readonly wizardPosition: number;
    };
};
export type AppQuery = {
    readonly response: AppQueryResponse;
    readonly variables: AppQueryVariables;
};



/*
query AppQuery {
  viewer {
    id
    firstName
    lastName
    email
    metadata
    profileImage {
      thumbImage
    }
    forceForPass
    preferences {
      dateFormat
      language
      timeFormat
      timezone
      uiInfo
      id
    }
    userRoles {
      role {
        levelDetails {
          __typename
          ... on Location {
            id
          }
          ... on Company {
            id
          }
          ... on Group {
            id
          }
          ... on Employee {
            id
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        levelId
        roleId
        role {
          id
          roleName
          isDefault
          priority
          level
          moduleRoles {
            name
          }
        }
      }
      id
    }
    groups {
      id
      name
      groupSettings {
        id
        adminCss
        metadata
        hasExtendedFields
      }
      companies {
        id
        title
        displayName
        profession
        active
        customCompanyId
        preference {
          currency
          dateFormat
          language
          timeFormat
          timezone
          uiInfo
          id
        }
        metadata
        gallery {
          default {
            thumbImage
            largeImage
          }
          images {
            largeImage
            thumbImage
          }
        }
        address {
          country
          latitude
          locality
          longitude
          postalCode
          region
          streetAddress
        }
        companySettings {
          id
          navMenus
          aliases(locale: "en-US")
          customization {
            disableApps
            disableStaffBooking
            displayIntakeFormField
          }
        }
        roleLevelCustomization {
          disableApps
          readonlyApps
          id
        }
        apps {
          id
          appTypeId
          name
          active
          serviceModules
        }
        slugObject {
          id
          slugType
          slugValue
        }
        telephones
        description
        emails
        locations(first: 500) {
          edges {
            node {
              id
              name
              customLocationId
              preference {
                currency
                dateFormat
                language
                timeFormat
                timezone
                uiInfo
                id
              }
              slugObject {
                id
                slugType
                slugValue
              }
              address {
                country
                latitude
                locality
                longitude
                postalCode
                region
                streetAddress
              }
              telephones
              description
              gallery {
                default {
                  largeImage
                  thumbImage
                }
                images {
                  largeImage
                  thumbImage
                }
              }
              active
              metadata
              appointmentBookingFlowSetting {
                id
                enableTierBasedStaffPrioritization
                tierEmployeeAllocation
              }
            }
          }
        }
        licenseWallet {
          license {
            moduleLicenses {
              enabled
              freeLimit
              licenseLimit
              maxAddonLimit
              maxLimit
              moduleName
              paidAddonLimit
              restrictionSlugs
              restrictionType
              rpcs
              slug
              totalLimit
            }
            id
          }
          id
        }
      }
    }
    tokenValidTill
  }
  wizardPosition {
    wizardPosition
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metadata",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbImage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "GalleryItem",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forceForPass",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateFormat",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeFormat",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uiInfo",
  "storageKey": null
},
v13 = [
  (v0/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Location",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Company",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Group",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Employee",
  "abstractKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "levelId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModuleRole",
      "kind": "LinkedField",
      "name": "moduleRoles",
      "plural": true,
      "selections": [
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupSetting",
  "kind": "LinkedField",
  "name": "groupSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminCss",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExtendedFields",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profession",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customCompanyId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v29 = [
  (v28/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largeImage",
  "storageKey": null
},
v31 = [
  (v30/*: any*/),
  (v5/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "GalleryItem",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Gallery",
  "kind": "LinkedField",
  "name": "gallery",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "default",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "region",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streetAddress",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableApps",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanySetting",
  "kind": "LinkedField",
  "name": "companySettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "navMenus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "locale",
          "value": "en-US"
        }
      ],
      "kind": "ScalarField",
      "name": "aliases",
      "storageKey": "aliases(locale:\"en-US\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyCustomization",
      "kind": "LinkedField",
      "name": "customization",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableStaffBooking",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayIntakeFormField",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readonlyApps",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "App",
  "kind": "LinkedField",
  "name": "apps",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appTypeId",
      "storageKey": null
    },
    (v20/*: any*/),
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceModules",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Slug",
  "kind": "LinkedField",
  "name": "slugObject",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugValue",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "telephones",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emails",
  "storageKey": null
},
v43 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customLocationId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Gallery",
  "kind": "LinkedField",
  "name": "gallery",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "default",
      "plural": false,
      "selections": (v31/*: any*/),
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentBookingFlowSetting",
  "kind": "LinkedField",
  "name": "appointmentBookingFlowSetting",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableTierBasedStaffPrioritization",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tierEmployeeAllocation",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "ModuleLicenses",
  "kind": "LinkedField",
  "name": "moduleLicenses",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freeLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "licenseLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxAddonLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moduleName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paidAddonLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "restrictionSlugs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "restrictionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rpcs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalLimit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenValidTill",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "GetWizardPositionResponse",
  "kind": "LinkedField",
  "name": "wizardPosition",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wizardPosition",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = [
  (v28/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserRole",
            "kind": "LinkedField",
            "name": "userRoles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRoleRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "levelDetails",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Group",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "companies",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyPreference",
                    "kind": "LinkedField",
                    "name": "preference",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleCustomization",
                    "kind": "LinkedField",
                    "name": "roleLevelCustomization",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": (v43/*: any*/),
                    "concreteType": "ListLocationResponse",
                    "kind": "LinkedField",
                    "name": "locations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Location",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v20/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LocationPreference",
                                "kind": "LinkedField",
                                "name": "preference",
                                "plural": false,
                                "selections": (v29/*: any*/),
                                "storageKey": null
                              },
                              (v39/*: any*/),
                              (v34/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v45/*: any*/),
                              (v26/*: any*/),
                              (v4/*: any*/),
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "locations(first:500)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseWallet",
                    "kind": "LinkedField",
                    "name": "licenseWallet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "License",
                        "kind": "LinkedField",
                        "name": "license",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v48/*: any*/)
        ],
        "storageKey": null
      },
      (v49/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserRole",
            "kind": "LinkedField",
            "name": "userRoles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRoleRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "levelDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Group",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "companies",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyPreference",
                    "kind": "LinkedField",
                    "name": "preference",
                    "plural": false,
                    "selections": (v50/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleCustomization",
                    "kind": "LinkedField",
                    "name": "roleLevelCustomization",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v37/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": (v43/*: any*/),
                    "concreteType": "ListLocationResponse",
                    "kind": "LinkedField",
                    "name": "locations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Location",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v20/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LocationPreference",
                                "kind": "LinkedField",
                                "name": "preference",
                                "plural": false,
                                "selections": (v50/*: any*/),
                                "storageKey": null
                              },
                              (v39/*: any*/),
                              (v34/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v45/*: any*/),
                              (v26/*: any*/),
                              (v4/*: any*/),
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "locations(first:500)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseWallet",
                    "kind": "LinkedField",
                    "name": "licenseWallet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "License",
                        "kind": "LinkedField",
                        "name": "license",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v48/*: any*/)
        ],
        "storageKey": null
      },
      (v49/*: any*/)
    ]
  },
  "params": {
    "cacheID": "77a4c5d8ca9b531eb49423783490c1fa",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery {\n  viewer {\n    id\n    firstName\n    lastName\n    email\n    metadata\n    profileImage {\n      thumbImage\n    }\n    forceForPass\n    preferences {\n      dateFormat\n      language\n      timeFormat\n      timezone\n      uiInfo\n      id\n    }\n    userRoles {\n      role {\n        levelDetails {\n          __typename\n          ... on Location {\n            id\n          }\n          ... on Company {\n            id\n          }\n          ... on Group {\n            id\n          }\n          ... on Employee {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        levelId\n        roleId\n        role {\n          id\n          roleName\n          isDefault\n          priority\n          level\n          moduleRoles {\n            name\n          }\n        }\n      }\n      id\n    }\n    groups {\n      id\n      name\n      groupSettings {\n        id\n        adminCss\n        metadata\n        hasExtendedFields\n      }\n      companies {\n        id\n        title\n        displayName\n        profession\n        active\n        customCompanyId\n        preference {\n          currency\n          dateFormat\n          language\n          timeFormat\n          timezone\n          uiInfo\n          id\n        }\n        metadata\n        gallery {\n          default {\n            thumbImage\n            largeImage\n          }\n          images {\n            largeImage\n            thumbImage\n          }\n        }\n        address {\n          country\n          latitude\n          locality\n          longitude\n          postalCode\n          region\n          streetAddress\n        }\n        companySettings {\n          id\n          navMenus\n          aliases(locale: \"en-US\")\n          customization {\n            disableApps\n            disableStaffBooking\n            displayIntakeFormField\n          }\n        }\n        roleLevelCustomization {\n          disableApps\n          readonlyApps\n          id\n        }\n        apps {\n          id\n          appTypeId\n          name\n          active\n          serviceModules\n        }\n        slugObject {\n          id\n          slugType\n          slugValue\n        }\n        telephones\n        description\n        emails\n        locations(first: 500) {\n          edges {\n            node {\n              id\n              name\n              customLocationId\n              preference {\n                currency\n                dateFormat\n                language\n                timeFormat\n                timezone\n                uiInfo\n                id\n              }\n              slugObject {\n                id\n                slugType\n                slugValue\n              }\n              address {\n                country\n                latitude\n                locality\n                longitude\n                postalCode\n                region\n                streetAddress\n              }\n              telephones\n              description\n              gallery {\n                default {\n                  largeImage\n                  thumbImage\n                }\n                images {\n                  largeImage\n                  thumbImage\n                }\n              }\n              active\n              metadata\n              appointmentBookingFlowSetting {\n                id\n                enableTierBasedStaffPrioritization\n                tierEmployeeAllocation\n              }\n            }\n          }\n        }\n        licenseWallet {\n          license {\n            moduleLicenses {\n              enabled\n              freeLimit\n              licenseLimit\n              maxAddonLimit\n              maxLimit\n              moduleName\n              paidAddonLimit\n              restrictionSlugs\n              restrictionType\n              rpcs\n              slug\n              totalLimit\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n    tokenValidTill\n  }\n  wizardPosition {\n    wizardPosition\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a5093e3f5a2ff4f564fec86cd0277eb2';
export default node;
